import React, { useState } from "react";
import Image from "components/image";
import Collapsible from "react-collapsible";
import RichText from "components/rich-text";
import clsx from "clsx/lite";
import { formatTitle } from "helpers/format-title";
import { ReactComponent as ArrowDown } from "assets/svgs/arrow-down.svg";
import { getRgba } from "helpers/get-rgba";
import Button from "components/button";

const ImagesAccordion = ({ data }) => {
	const [activeAccordionIndex, setActiveAccordionIndex] = useState(data?.firstOpened ? 0 : null);
	const [lastOpenedIndex, setLastOpenedIndex] = useState(0);
	const [imageLoaded, setImageLoaded] = useState(true);

	const togglePanel = (index) => {
		setActiveAccordionIndex((prevIndex) => {
			const isClosing = prevIndex === index;
			if (isClosing) return null;
			setImageLoaded(false);

			setTimeout(() => {
				setLastOpenedIndex(index);
				setImageLoaded(true);
			}, 200);
			return index;
		});
	};

	return (
		<div className="md:w-10/12 w-11/12 2xl:w-8/12 md:lg-4/5 m-auto max-w-screen-xl">
			<div className="lg:px-60 my-3 lg:my-0"><RichText value={data?.text} /></div>
			<div className="flex gap-9 md:gap-20 mt-2 md:mt-14 flex-col md:flex-row box-border">
				<div className="md:w-1/2 content-center">
					{data.accordion[lastOpenedIndex]?.image && (
						<div
							className={clsx(
								"transition-opacity duration-300 ease-in-out",
								imageLoaded ? "opacity-100" : "opacity-0"
							)}
						>
							<Image
								image={data.accordion[lastOpenedIndex].image}
								className={clsx(!data?.showOriginalImg && "rounded-2xl aspect-square")} />
						</div>
					)}
				</div>
				<div className="md:w-1/2">
					{data.accordion.map((c, i) => {
						const isOpen = i === activeAccordionIndex;
						const isLastItem = i === data.accordion.length - 1;
						return (
							<Collapsible
								className={clsx("!border-t border-[#E3E3E3]", isLastItem && "border-b")}
								openedClassName={clsx("!border-t border-[#E3E3E3]", isLastItem && "border-b")}
								key={c._key}
								transitionTime="200"
								triggerTagName="div"
								triggerElementProps={{ id: c._key }}
								contentElementId={c._key}
								open={isOpen}
								onTriggerOpening={() => togglePanel(i)}
								onTriggerClosing={() => togglePanel(i)}
								trigger={[
									<div key={c.title} className="flex items-center gap-4">
										{c?.icon?.asset && <div style={{ backgroundColor: getRgba(data?.iconsBgColor) || "transparent" }}
											className="rounded-full size-10 flex items-center justify-center">
											<Image className="size-6" image={c.icon} />
										</div>}
										<span className="py-6 text-dark-blue text-lg">{formatTitle(c.title)} </span>
									</div>,
									<ArrowDown key={c.key} className={clsx(
										"uppercase block float-right transition-all duration-600 self-center",
										isOpen && "rotate-180 mb-2",
									)} />
								]}
							>
								<div className="pb-6 text-[#2D3246] text-base">
									<RichText value={c.content} />
								</div>
							</Collapsible>
						);
					})}
				</div>
			</div>
			<Button className="mt-15" textUnderneathClass="text-lg" containerClassName="w-full md:w-fit" data={data?.cta} />
		</div>
	);
};

export default ImagesAccordion;
